/** Paginated listing of the prices. */
import { infiniteQueryOptions } from '@tanstack/react-query';
import { api } from '@/shared/api/client';
import { anyDmsData, dmsPageSchema, type DmsPage } from '../api';

export interface PriceListParams {
  search: string;
  sortBy: string | null;
  sortOrder: 'asc' | 'desc';
  refresh: number;
}

/** GET dms-item/prices: the prices, searched by style code and sorted by the API. */
export const pricePagesQueryOptions = ({
  search,
  sortBy,
  sortOrder,
  refresh,
}: PriceListParams) =>
  infiniteQueryOptions({
    queryKey: [
      'dms-items',
      'price',
      'pages',
      { search, sortBy, sortOrder, refresh },
    ] as const,
    queryFn: ({ pageParam }) =>
      api.get<DmsPage>('dms-item/prices', {
        query: {
          sortOrder,
          ...(sortBy ? { sortBy } : {}),
          ...(search ? { search } : {}),
          ...(pageParam ? { after: pageParam } : {}),
        },
        schema: dmsPageSchema(anyDmsData),
      }),
    initialPageParam: '' as string,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    retry: false,
  });
